// Generated by pnpm --filter @langfuse/icons generate. Do not edit.
import { createIcon } from "../../create-icon.js";
import { LucidePlus as RawLucidePlus } from "lucide-react";
export const LucidePlus = /* @__PURE__ */ createIcon(RawLucidePlus, "LucidePlus", 2);
